import FormatGeoJSON from '../node_modules/ol/format/GeoJSON.js';

import bboxClip from '../node_modules/@turf/bbox-clip';

/**
 * Returns an OpenLayers point object (or undefined) that is within the current
 * view extent and within the feature. Useful for labeling polygons.
 * feature may be a polygon or multi-polygon.
 * Uses TurfJs to clip the feature to the extent of the current map view.
 * @param {Feature} feature
 */

export default function(feature) {
  const formatGeoJSON = new FormatGeoJSON()
  const clippedFeature = bboxClip(
    formatGeoJSON.writeGeometryObject(feature.getGeometry()), // ol feature converted to geoJSON format
    this.map.getView().calculateExtent()    // current map view extent
  )
  let p
  if (clippedFeature.geometry.coordinates.length) {
    let oLgeom
    try {
      oLgeom = formatGeoJSON.readGeometry(clippedFeature.geometry) // geoJSON obj converted to an ol feature
    } catch (error) {
      console.warn ('Caught pointInPolyInView', error)
    }
    if (oLgeom.getType() === 'MultiPolygon') {  // test: https://www2.greenwoodmap.com/sheridan/dev#zcr=14.080328381998555/-11907719.978529334/5588770.941466087/0&lyrs=senatehouse2022
      let polys = oLgeom.getPolygons()
      let area
      let previousArea = 0
      let largest = -1
      polys.forEach((e, i) => {
        area = e.getArea()
        if (area > previousArea) {
          previousArea = area
          largest = i
        }
      })
      if (largest > -1) {
        p = polys[largest].getInteriorPoint()
      }
    } else {
      p = oLgeom.getInteriorPoint()
    }

    if (p && p.getCoordinates()[2] > 0) { // using M to ensure that point is within polygon
      return p
    }
  }
}
